var config = {
  web: {
    server_base: 'api.cltdev.com',
    server_protocol: 'https',
  }
};

export default config;
